(function (angular) {
	'use strict';

	angular
		.module('toastModule', [
			'BaseConfig'
		])
		.value('initialToasts', initialToasts);
})(window.angular);